<script setup>
import { ref } from 'vue';
import example1Img from '../../../../assets/images/example1.webp';
import example2Img from '../../../../assets/images/example2.webp';
import example3Img from '../../../../assets/images/example3.webp';
import example4Img from '../../../../assets/images/example4.webp';

const serviceCases = ref([
  {
    id: 1,
    title: '順德古樓宇風水堪輿',
    image: example1Img,
  },
  {
    id: 2,
    title: '百度風水堪輿',
    image: example2Img,
  },
  {
    id: 3,
    title: '新世界地產‧廣匯尊府',
    image: example3Img,
  },
  {
    id: 4,
    title: '南海·碧桂園',
    image: example4Img,
  },
]);
</script>

<template>
  <section class="service-case-section">
    <h2 class="section-title">服務案例</h2>
    <div class="cases-container">
      <div
        v-for="caseItem in serviceCases"
        :key="caseItem.id"
        class="case-card"
      >
        <div class="case-image-container">
          <img
            :src="caseItem.image"
            :alt="caseItem.title"
            class="case-image"
          />
        </div>
        <p class="case-title">{{ caseItem.title }}</p>
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
.service-case-section {
  width: 100%;
  padding: 20px 40px 10px;
  background: #ffffff;
}

.section-title {
  font-size: 15px;
  color: rgb(29, 32, 35);
  text-align: center;
  margin-bottom: 20px;
}

.cases-container {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
}

.case-card {
  background: #ffffff;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  cursor: pointer;
}

.case-image-container {
  width: 100%;
  overflow: hidden;

  .case-image {
    width: 100%;
    height: auto;
    display: block;
    object-fit: cover;
  }
}

.case-title {
  font-size: 8px;
  color: #333333;
  text-align: center;
  padding: 5px;
  margin: 0;
  line-height: 1.4;
}
</style>
